// src/pages/Dashboard/MySubscription/styles.ts
import type { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    maxWidth: 1000,
    margin: '0 auto',
    mt: 4,
  },
  subtitle: {
    color: 'gray',
    mb: 3,
  },
  // renomeei subscriptionBox → cardBox
  cardBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    border: '2px solid #333',
    borderRadius: 4,
    p: 3,
    alignItems: 'center',
    gap: 4,
  },
  // renomeei image → imageStyle
  imageStyle: {
    maxWidth: 120,
  },
  // novas entradas para texto verde
  boldGreenText: {
    color: '#333',
    fontWeight: 'bold',
    mb: 1,
  },
  greenText: {
    color: '#333',
  },
  idText: {
    color: '#333',
    fontWeight: 'bold',
    mb: 1,
    fontSize: '0.9rem',
  },
  // renomeei statusBadge → statusBox
  statusBox: {
    border: '2px solid #333',
    color: '#333',
    textAlign: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    fontWeight: 'bold',
    px: 2,
    py: 0.5,
  },
  statusTitle: {
    fontWeight: 'bold',
    color: '#333',
  },
  addressBox: {
    backgroundColor: '#f5f5f5',
    borderRadius: 2,
    p: 2,
    mt: 1,
    width: 260,
  },
  // opcional: estilizar as ações
  actions: {
    display: 'flex',
    gap: 2,
    justifyContent: 'flex-end',
    mt: 2,
  },
  cardLink: {
    mt: 2,
    display: 'inline-block',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: 'black',
  },
};

export default styles;
